export const VIDEOS_ASPECT_RATIO = 16 / 9;
